/* NOTES */
export const LIST_NOTES = "LIST_NOTES"
export const LIST_NOTES_SUCCESS = "LIST_NOTES_SUCCESS"
export const LIST_NOTES_CLEAN = "LIST_NOTES_CLEAN"
export const LIST_NOTES_ERROR = "LIST_NOTES_ERROR"
